export default () => ({
  isOpen: false,

  Button: {
    ["@click"]() {
      this.isOpen = true;
    },
  },

  Panel: {
    ["x-show"]() {
      return this.isOpen;
    },
    ["x-cloak"]() {
      return true;
    },
    ["@click.outside"]() {
      this.isOpen = false;
    },
  },
});



// WEBPACK FOOTER //
// ./scripts/components/Disclosure.js